import { createContext, useContext, useReducer, useState, useEffect } from "react";
import { getDownloadURL } from "firebase/storage";
import { storageRef } from "../firebase";
import { imgRef, featuredImgRef } from "../firebase";
import { ref } from "firebase/storage";

export const ImageContext = createContext();
export const useImages = ()=>{
    return useContext(ImageContext)
}



export const ImageProvider = ({children})=>{
    const [Image, setImage] = useState()
    const getData = async()=>{
        const img1Ref = ref(featuredImgRef, "img1");
        const img2Ref = ref(featuredImgRef, "img2");
        const img3Ref = ref(featuredImgRef, "img3");
        const aboutImage = await getDownloadURL(imgRef)
        const featuredImg1 = await getDownloadURL(img1Ref)
        const featuredImg2 = await getDownloadURL(img2Ref)
        const featuredImg3 = await getDownloadURL(img3Ref)
        
        setImage({aboutImage, featuredImg1, featuredImg2, featuredImg3})
    }
  useEffect(()=>{
    getData()
  }, [])

    return <ImageContext.Provider value={[Image, setImage]}>
        {children}
    </ImageContext.Provider>
}